import React, { Component } from "react";
import ConteudoResumo from "./ConteudoResumo";
import Controlos from "../../components/Controlos";
import { GlobalContext } from "../../../../app/providers/GlobalState";
import LazyLoad from "react-lazy-load";

class Resumo extends Component {
    static contextType = GlobalContext;

    render() {
        const { curso, aula } = this.props.match.params;

        return (
            <div className="questionario-resumo">
                <div className="player-wrapper">
                    <ConteudoResumo
                        redirectLink={`/gerir-curso/${curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/${aula
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                            .toLowerCase()}/player-questionario`}
                        redirectLinkResolucao={`/gerir-curso/${curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/${aula
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                            .toLowerCase()}/player-questionario-resolucao`}
                    />
                    <Controlos
                        backUrl={`/gerir-curso/${this.props.match.params.curso
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                            .toLowerCase()}/curso-modulos`}
                        sameUrl={true}
                        temAnotacoes
                    />
                </div>
            </div>
        );
    }
}

export default Resumo;
